import createIcon from '../../createIcon';

/**
 * @component @name Forward10
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTRDMTggMTcuMzEgMTUuMzEgMjAgMTIgMjBDOC42OSAyMCA2IDE3LjMxIDYgMTRDNiAxMC42OSA4LjY5IDggMTIgOFYxMkwxNyA3TDEyIDJWNkM3LjU4IDYgNCA5LjU4IDQgMTRDNCAxOC40MiA3LjU4IDIyIDEyIDIyQzE2LjQyIDIyIDIwIDE4LjQyIDIwIDE0SDE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwLjg2IDE2Ljk0VjEyLjY3SDEwLjc3TDkgMTMuM1YxMy45OUwxMC4wMSAxMy42OFYxNi45NEgxMC44NloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMi4yNSAxNC40NFYxNS4xOEMxMi4yNSAxNy4wOCAxMy41NiAxNyAxMy42OSAxN0MxMy44MyAxNyAxNS4xMyAxNy4wOSAxNS4xMyAxNS4xOFYxNC40NEMxNS4xMyAxMi41NCAxMy44MiAxMi42MiAxMy42OSAxMi42MkMxMy41NSAxMi42MiAxMi4yNSAxMi41MyAxMi4yNSAxNC40NFpNMTQuMjkgMTQuMzJWMTUuMjlDMTQuMjkgMTYuMDYgMTQuMDggMTYuMzIgMTMuNyAxNi4zMkMxMy4zMiAxNi4zMiAxMy4xIDE2LjA2IDEzLjEgMTUuMjlWMTQuMzJDMTMuMSAxMy41NyAxMy4zMiAxMy4zMSAxMy42OSAxMy4zMUMxNC4wNyAxMy4zIDE0LjI5IDEzLjU3IDE0LjI5IDE0LjMyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Forward10 = createIcon('Forward10', [
  [
    'path',
    {
      d: 'M18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14C6 10.69 8.69 8 12 8V12L17 7L12 2V6C7.58 6 4 9.58 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14H18Z',
      key: '1ldjgn',
    },
  ],
  ['path', { d: 'M10.86 16.94V12.67H10.77L9 13.3V13.99L10.01 13.68V16.94H10.86Z', key: 'p2jo3k' }],
  [
    'path',
    {
      d: 'M12.25 14.44V15.18C12.25 17.08 13.56 17 13.69 17C13.83 17 15.13 17.09 15.13 15.18V14.44C15.13 12.54 13.82 12.62 13.69 12.62C13.55 12.62 12.25 12.53 12.25 14.44ZM14.29 14.32V15.29C14.29 16.06 14.08 16.32 13.7 16.32C13.32 16.32 13.1 16.06 13.1 15.29V14.32C13.1 13.57 13.32 13.31 13.69 13.31C14.07 13.3 14.29 13.57 14.29 14.32Z',
      key: 'jc1pjv',
    },
  ],
]);

export default Forward10;
